import { ENTITY_TYPES, type EntityType } from '@/lib/constants/entity-types';

/**
 * Per-entity-type Team & Permissions features - profile sharing (MYN-41/54:
 * the Share Profile button + Shared Profile Recipients section), DAXE seat
 * billing (FR-45), and whether this entity type has perks at all - each
 * applies to exactly one entity type today. Kept as one map, not a scattered
 * `entityType === 'startup'` check, so extending any of them to a new entity
 * type later is one edit here.
 *
 * `offerAccess` no longer adds a column. MYN-181 merged the separate
 * Create/Publish Offer Access grant into the edit toggle, so it now only
 * selects that column's wording: "Edit Profile / Perk" for a partner,
 * "Edit Profile Access" for an entity type with no perks to name.
 *
 * `inviteSector` (MYN-202, FR-174) turns on the optional "Sector / area of
 * work" pick on the invite dialog and the Sector column. It mirrors the
 * Backend's `ENTITY_INVITE_OPTIONS` (Investor only), which refuses a sector on
 * any other type.
 */
export interface TeamPageFeatures {
  sharing: boolean;
  daxeSeats: boolean;
  offerAccess: boolean;
  inviteSector: boolean;
}

export const TEAM_PAGE_FEATURES: Record<EntityType, TeamPageFeatures> = {
  [ENTITY_TYPES.STARTUP]: { sharing: true, daxeSeats: true, offerAccess: false, inviteSector: false },
  [ENTITY_TYPES.INVESTOR]: { sharing: false, daxeSeats: false, offerAccess: false, inviteSector: true },
  [ENTITY_TYPES.TRUSTED_PARTNER]: { sharing: false, daxeSeats: false, offerAccess: true, inviteSector: false },
};
